module.exports = __webpack_public_path__ + "img/format.ac70d526.png";